module.exports = __webpack_public_path__ + "static/media/flexible-1.8355cd07.png";